import axios from 'axios';

const getFarmerAppointments = (farmerID) =>
  axios
    .get(`${process.env.REACT_APP_API_URL}/api/appointment/farmerAppointments/${farmerID}`)
    .then(res => res)
    .catch(err => err);

export default getFarmerAppointments;
